import { useEffect, useState } from "react";
import LoadingDots from "src/pages/game-new2/components/loadingDots";
import moment from "moment";
import cn from "classnames";

import { Avatar } from "src/shared/ui/Avatar";

import { Player } from "../Player";

import { useStyles } from "./styles";
import { Searching } from "./Searching";
import { IUserNew } from "src/store/models";

interface IPlayer {
    avatarUrl: string;
    nickname: string;
    id: string;
    stars?: number;
}
export interface IPlayersProps {
    player1: IPlayer;
    createdAt: string;
    player2?: IPlayer;
    isMobile?: boolean;
    me?: IUserNew;
}

export const Players = ({
    player1,
    player2,
    createdAt,
    isMobile,
    me,
}: IPlayersProps) => {
    const classes = useStyles();

    const myAwaitingGame = me && me._id === player1.id && !player2;
    const started = !!player2 && !!player1 && !!player2.id && !!player1.id;

    if (isMobile) {
        return (
            <div
                className={cn(classes.wrapperPlayers, {
                    seeOtherAwaitingGame: !myAwaitingGame && !started,
                })}
            >
                <Player
                    avatarUrl={player1.avatarUrl}
                    nickname={player1.nickname}
                    isMobile={isMobile}
                    className={cn(classes.bothPlayers, "top", {
                        topStarted: started,
                    })}
                    id={player1.id}
                    stars={player1.stars || 0}  
                />
                {myAwaitingGame && (
                    <LoadingDots
                        size={10}
                        color="#00BA6C"
                        time={0.05}
                        delay={0.5}
                        className={classes.centred}
                        stopped={false}
                    />
                )}
                {player2 && (
                    <Player
                        avatarUrl={player2.avatarUrl}
                        nickname={player2.nickname}
                        isMobile={isMobile}
                        className={cn(classes.bothPlayers, "bottom", {
                            bottomStarted: started,
                        })}
                        id={player2.id}
                        stars={player2.stars || 0}  
                    />
                )}
            </div>
        );
    }

    return (
        <div className={classes.wrapperPlayers}>
            <Player
                avatarUrl={player1.avatarUrl}
                nickname={player1.nickname}
                id={player1.id}
                stars={player1.stars || 0}  
            />
            <div className={classes.versusWrapper}>
                <div className={classes.versusLine} />
                <span className={classes.versusText}>VS</span>
                <div className={classes.versusLine} />
            </div>
            {player2 ? (
                <Player
                    avatarUrl={player2.avatarUrl}
                    nickname={player2.nickname}
                    id={player2.id}
                    stars={player2.stars || 0}  
                />
            ) : (
                <Searching createdAt={createdAt} />
            )}
        </div>
    );
};
